import React from "react";

// Project Imports
import WithLayout from "../../../components/WithLayout";
import Admin from "../../../layouts/Admin";
import VisitComponent from "../../../views/Admin/Visit";

// =================== Order Page ================= //
const Visit = () => {
  return <WithLayout layout={Admin} component={VisitComponent} />;
};

export default Visit;